import prependParentNode from './prependParentNode';

const preloadScript = async (href: string) =>
    prependParentNode<HTMLLinkElement>('link', {
        href,
        rel: 'preload',
        as: 'script',
    });

export default preloadScript;
